import { createRoute } from '@tanstack/react-router';
import { adminParentRoute } from 'pages/admin/adminParentRoute';

export const adminSelloutPanelistGeneratorRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: '/tools/sellout_panelist_generator',
}).lazy(() =>
  import(
    'pages/admin/SelloutPanelistGenerator/AdminSelloutPanelistGeneratorPage/AdminSelloutPanelistGeneratorPage'
  ).then((d) => d.Route)
);
